export default __webpack_public_path__ + "95ffca3c896d79c6410f4c15eafa8624.png";